import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/** The focus ring is a 2px spread outside the hole: keep that much of the viewport around it. */
const RING_PX = 2;
/**
 * The hole — target plus padding — clamped to the viewport, less the ring.
 * A header control flush with the top edge (the bell, «راهنما») once had its
 * top ring and padding drawn above the screen, so the highlight read as a
 * box open at the top. Pure, for the test.
 */
export function spotlightBox(rect, padding, viewport) {
    const left = Math.max(RING_PX, rect.left - padding);
    const top = Math.max(RING_PX, rect.top - padding);
    const right = Math.min(viewport.width - RING_PX, rect.left + rect.width + padding);
    const bottom = Math.min(viewport.height - RING_PX, rect.top + rect.height + padding);
    return {
        left: Math.round(left),
        top: Math.round(top),
        width: Math.round(Math.max(0, right - left)),
        height: Math.round(Math.max(0, bottom - top)),
    };
}
/**
 * The blocker and the spotlight of a floating/sheet step.
 *
 * The BLOCKER is a transparent full-viewport layer: clicks do nothing (the
 * spotlit target is shown, not operated — "do, don't show" steps are a
 * non-goal) and a mousedown cannot pull focus out of the panel. The wheel is
 * not intercepted, so the document still scrolls and the spotlight follows.
 *
 * The SPOTLIGHT is one box around the target whose enormous spread shadow is
 * the scrim, so the hole is exactly the target plus padding with no masking or
 * SVG. Without a target it becomes a plain full-viewport scrim.
 */
export function Spotlight({ rect, padding, }) {
    const block = (event) => {
        event.preventDefault();
    };
    const box = rect
        ? spotlightBox(rect, padding, { width: window.innerWidth, height: window.innerHeight })
        : null;
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "bk-coachmark__blocker", "aria-hidden": "true", onMouseDown: block, onClick: block }), box ? (_jsx("div", { className: "bk-coachmark__spotlight", "aria-hidden": "true", style: {
                    transform: `translate(${box.left}px, ${box.top}px)`,
                    width: box.width,
                    height: box.height,
                } })) : (_jsx("div", { className: "bk-coachmark__spotlight bk-coachmark__spotlight--full", "aria-hidden": "true" }))] }));
}
//# sourceMappingURL=spotlight.js.map